import { render, staticRenderFns } from "./DetalheTotalClientes.vue?vue&type=template&id=7be43fb7&scoped=true&"
import script from "./DetalheTotalClientes.vue?vue&type=script&lang=js&"
export * from "./DetalheTotalClientes.vue?vue&type=script&lang=js&"
import style0 from "./DetalheTotalClientes.vue?vue&type=style&index=0&id=7be43fb7&scoped=true&lang=css&"
import style1 from "./DetalheTotalClientes.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be43fb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VIcon,VRow,VTooltip})
